"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtilizationMetric = exports.ProductionMetric = exports.ProductivityUtilisationMetricInput = void 0;
var ProductivityUtilisationMetricInput;
(function (ProductivityUtilisationMetricInput) {
    ProductivityUtilisationMetricInput["NoInput"] = "No Input";
    ProductivityUtilisationMetricInput["AnalogInput1AndOr2"] = "Analog Input 1 AND/OR Analog Input 2";
    ProductivityUtilisationMetricInput["AnalogInput1"] = "Analog Input 1";
    ProductivityUtilisationMetricInput["AnalogInput2"] = "Analog Input 2";
    ProductivityUtilisationMetricInput["AnalogInput3"] = "Analog Input 3";
    ProductivityUtilisationMetricInput["AnalogInput4"] = "Analog Input 4";
    ProductivityUtilisationMetricInput["AnalogOutput1"] = "Analog Output 1";
    ProductivityUtilisationMetricInput["BleFuelFrequency1"] = "Ble Frequency 1";
})(ProductivityUtilisationMetricInput = exports.ProductivityUtilisationMetricInput || (exports.ProductivityUtilisationMetricInput = {}));
var ProductionMetric;
(function (ProductionMetric) {
    ProductionMetric["MaterialMoved"] = "MaterialMoved";
    ProductionMetric["DistanceTravelled"] = "DistanceTravelled";
    ProductionMetric["DistancePushed"] = "DistancePushed";
    ProductionMetric["DistancePaved"] = "DistancePaved";
    ProductionMetric["TimeGraded"] = "TimeGraded";
    ProductionMetric["HoursActive"] = "HoursActive";
    ProductionMetric["LoadsCarried"] = "LoadsCarried";
    ProductionMetric["SprayTime"] = "SprayTime";
    ProductionMetric["ArcTime"] = "ArcTime";
    ProductionMetric["DispensingTime"] = "DispensingTime";
    ProductionMetric["Cycles"] = "Cycles";
    ProductionMetric["HammeringTime"] = "HammeringTime";
    ProductionMetric["DistanceGraded"] = "DistanceGraded";
    ProductionMetric["DistanceCompacted"] = "DistanceCompacted";
    ProductionMetric["PilingTime"] = "PilingTime";
    ProductionMetric["WaterConsumed"] = "WaterConsumed";
    ProductionMetric["CompactingArea"] = "CompactingArea";
    ProductionMetric["GradingArea"] = "GradingArea";
    ProductionMetric["VolumeOfEarthMoved"] = "VolumeOfEarthMoved";
    ProductionMetric["WeightLifted"] = "WeightLifted";
    ProductionMetric["LiftedTime"] = "LiftedTime";
    ProductionMetric["HydraulicsActivatedTime"] = "HydraulicsActivatedTime";
    ProductionMetric["LoadPercentOnGenerator"] = "LoadPercentOnGenerator";
})(ProductionMetric = exports.ProductionMetric || (exports.ProductionMetric = {}));
var UtilizationMetric;
(function (UtilizationMetric) {
    UtilizationMetric["BoomActivated"] = "BoomActivated";
    UtilizationMetric["BucketMovement"] = "BucketMovement";
    UtilizationMetric["Movement"] = "Movement";
    UtilizationMetric["HydraulicsActivated"] = "HydraulicsActivated";
    UtilizationMetric["MixingActivated"] = "MixingActivated";
    UtilizationMetric["SprayActivated"] = "SprayActivated";
    UtilizationMetric["ArcRate"] = "ArcRate";
    UtilizationMetric["DispensingRate"] = "DispensingRate";
    UtilizationMetric["AugerActivated"] = "AugerActivated";
    UtilizationMetric["RPM"] = "RPM";
    UtilizationMetric["LoadsCarried"] = "LoadsCarried";
    UtilizationMetric["BladeActivated"] = "BladeActivated";
    UtilizationMetric["ElevationActivated"] = "ElevationActivated";
    UtilizationMetric["KomatsuDozerActivated"] = "KomatsuDozerActivated";
    UtilizationMetric["GeneratorActivated"] = "GeneratorActivated";
})(UtilizationMetric = exports.UtilizationMetric || (exports.UtilizationMetric = {}));
//# sourceMappingURL=vision.js.map